import { Component, OnInit } from '@angular/core';
import { Invoice } from '../invoice';
import { InvoiceService } from '../invoice.service';
import { InvoiceListPipe } from '../../pipe/invoicelist.pipe';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from '../../auth.service';

import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {

  closeResult: string; 
  SerchText:string ='';

  page=1;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  totalrecord:number;
  invoice = new Invoice();  //Po is defined from abobe import po
  invoices: Invoice[];
  submitted = false;
	message: string;	
  invoiceFilter: any = { invoiceno: '' };
  public DeleteInvoice = "none"
  public selectedInvoiceID;
  constructor(
    private invoiceService: InvoiceService,
    private route: ActivatedRoute,
    private location: Location,
    private modalService: NgbModal,
	 private auth: AuthService
  ) { }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  ngOnInit() {
    this.getInvoices();
  }

  GetInvoicesDetail(invoiceid) {
    // const id = +this.route.snapshot.paramMap.get('poid');
     this.invoiceService.GetInvoicesDetail(invoiceid)
       .subscribe(invoice => this.invoice = invoice);
   }

  getInvoices() {
	  
	  if(this.auth.currentUserValue.userroleid !=4)
	  {
			return this.invoiceService.getInvoices()
					   .subscribe(
						invoices => {
						
						  this.invoices = invoices;
						  this.totalrecord =this.invoices.length;
						 }
						);
	  }
	  else
	  {
		  			return this.invoiceService.GetPoCreatorInvoices(this.auth.currentUserValue.userid)
					   .subscribe(
						invoices => {
						
						  this.invoices = invoices;
						  this.totalrecord =this.invoices.length;
						 }
						);

	  }
 }

 update(): void {
  this.submitted = true;
  this.invoiceService.updateInvoice(this.invoice)
      .subscribe(() => this.message = "Invoice Updated Successfully!");
}

delete(invoiceid): void {
 // this.submitted = true;
 this.invoiceService.GetInvoicesDetail(invoiceid)
       .subscribe(invoice => {
				this.invoice = invoice
				this.invoice.isdeleted=1;
				this.invoiceService.updateInvoice(this.invoice)
			.subscribe(() => 
			{
        this.message = "Invoice Deleted Successfully!";
        this.closeDeleteInvoice();
				 this.getInvoices();
			});
	   });
 
     
}

  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

OpenDeleteInvoice(invoiceID){
  this.selectedInvoiceID = invoiceID
  this.DeleteInvoice='block'; 
 }

 closeDeleteInvoice(){
  this.DeleteInvoice='none'; 
}

}
